import React, { ReactElement } from 'react';
import Error500 from './Error500';
import { ErrorBoundary } from 'react-error-boundary';
import NotFoundError404 from './NotFoundError404';
import Error404 from './Error404';
import { useHistory } from 'react-router-dom';
import AppProviders from '../../AppProviders';
import AppLayoutTemplate from '../layout/AppLayoutTemplate';
import AppContentTemplate from '../layout/AppContentTemplate';

type Props = {
    children: ReactElement;
};

function AppErrorBoundary({ children }: Props) {
    const onErrorHandler = (error: Error, info: { componentStack: string }) => {
        if (!(error instanceof NotFoundError404)) {
            console.error(
                'ErrorBoundary caught an error:',
                error,
                info.componentStack
            );
        }
    };

    return (
        <ErrorBoundary
            FallbackComponent={AppErrorFallback}
            onError={onErrorHandler}
            onReset={() => {
                // reset the state of your app so the error doesn't happen again
            }}
        >
            {children}
        </ErrorBoundary>
    );
}

type AppErrorFallbackProps = {
    error: Error;
    resetErrorBoundary: Function;
};

function AppErrorFallback({
    error,
    resetErrorBoundary,
}: AppErrorFallbackProps) {
    let history = useHistory();

    const handleHomeClick = () => {
        history.push({
            pathname: '/',
        });
        resetErrorBoundary?.();
    };

    if (error instanceof NotFoundError404) {
        return (
            <AppProviders>
                <AppLayoutTemplate>
                    <AppContentTemplate>
                        <Error404 onHomeClick={handleHomeClick} />
                    </AppContentTemplate>
                </AppLayoutTemplate>
            </AppProviders>
        );
    } else {
        return (
            <AppLayoutTemplate showHeader={false}>
                <AppContentTemplate>
                    <Error500 error={error} onHomeClick={handleHomeClick} />
                </AppContentTemplate>
            </AppLayoutTemplate>
        );
    }
}

export default AppErrorBoundary;
